
import { useState } from 'react';
import BusinessCard from './BusinessCard';

interface Business {
  id: number;
  name: string;
  tagline: string;
  category: string;
  description: string;
  address: string;
  phone: string;
  website: string;
  image: string;
  logo: string;
  rating: number;
  reviews: number;
  featured: boolean;
  verified: boolean;
  offer: string;
  openNow: boolean;
  hours: string;
  priceRange: string;
}

interface DirectoryGridProps {
  businesses: Business[];
}

const PAGE_SIZE = 9;

export default function DirectoryGrid({ businesses }: DirectoryGridProps) {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  const visible = businesses.slice(0, visibleCount);
  const hasMore = visibleCount < businesses.length;

  return (
    <div className="flex-1 min-w-0">
      {/* Results count */}
      <div className="flex items-center justify-between mb-6">
        <p className="text-sm text-gray-500">
          Showing <strong className="text-gray-900">{Math.min(visibleCount, businesses.length)}</strong> of{' '}
          <strong className="text-gray-900">{businesses.length}</strong> businesses
        </p>
      </div>

      {businesses.length === 0 ? (
        <div className="text-center py-20">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-store-2-line text-gray-400 text-2xl"></i>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No businesses found</h3>
          <p className="text-sm text-gray-500 max-w-md mx-auto">
            Try adjusting your search or filters to find what you&apos;re looking for.
          </p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {visible.map((biz) => (
              <BusinessCard key={biz.id} business={biz} />
            ))}
          </div>

          {hasMore && (
            <div className="text-center mt-10">
              <button
                onClick={() => setVisibleCount((prev) => prev + PAGE_SIZE)}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full border-2 border-gray-200 text-sm font-semibold text-gray-700 hover:border-teal-500 hover:text-teal-600 transition-all cursor-pointer whitespace-nowrap"
              >
                Load More Businesses
                <i className="ri-arrow-down-line"></i>
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
